import CityGuideMap from './CityGuideMap';
import HighlightsList from './HighlightsList';
import { resultData } from './mocked-data';
import './styles.scss';
import { useEffect, useState } from 'react';
import { SanityPlace } from '../../pages/CityGuide/CityGuide.types';

interface CityGuideMapSectionProps {
  places: Array<SanityPlace>;
  city: string;
}

function CityGuideMapSection({ places, city }: CityGuideMapSectionProps) {
  const [showInfo, setShowInfo] = useState<any>(null);
  const [center, setCenter] = useState<any>(null);

  const calculateCenter = () => {
    let long = 0;
    let lat = 0;
    let count = 0;
    places.map((each: SanityPlace) => {
      if (each.location) {
        long += each.location.lng;
        lat += each.location.lat;
        count++;
      }
    });
    if (count) {
      setCenter({ lat: lat / count, lng: long / count });
    }
  };

  useEffect(() => {
    if (!!places && places.length) {
      calculateCenter();
    }
  }, [places]);

  return (
    <div className={'row flex city-guide-map-section'}>
      <div className="col-lg-4 col-12 px-3">
        <HighlightsList places={places} city={city} showInfo={showInfo} setShowInfo={setShowInfo} />
      </div>
      <div className="col-lg-8 col-12 px-0 px-md-5 py-3">
        {center && <CityGuideMap center={center} places={places} showInfo={showInfo} setShowInfo={setShowInfo} />}
      </div>
    </div>
  );
}

export default CityGuideMapSection;
